<div class="card-header">
  <app-breadcrumb currentPage="Rapporten"></app-breadcrumb>
</div>

<div class="card-body">
  <button class="btn plus btn-left float-left"
          (click)="generateReportsNewYear()">
    genereer rapporten
  </button>
  <mat-paginator [length]="totalElements"
                 [pageSize]="pageSize"
                 [pageSizeOptions]="pageSizeOptions"
                 (page)="pageEvent = updatePage($event)">
  </mat-paginator>
  <table matSort (matSortChange)="sortPage($event)" class="table full-width">
    <thead>
    <tr>
      <th mat-sort-header="report.client.name.firstName">Bewind</th>
      <th mat-sort-header="report.reportType.code">Rapport</th>
      <th mat-sort-header="report.year">Jaar</th>
      <th mat-sort-header="createdAt">Datum</th>
    </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of content" class="pointer" (click)="download(row)">
        <td>{{row.clientFullName}}</td>
        <td>{{row.type}}</td>
        <td>{{row.year}}</td>
        <td>{{row.finishedReport.createdAt}}</td>
      </tr>
    </tbody>
  </table>
</div>
